import React from 'react';
import { BrainGraph } from '../components/deck/BrainGraph';
import { Slide } from '../components/deck/Slide';
import { Body, Display, Eyebrow, Reveal } from '../components/deck/Type';
export function CoverSlide() {
  return <Slide index={1} variant="deep" data-id="element-77" data-mp="gazovhxyqlif">
      <div className="grid min-h-0 flex-1 grid-cols-[54%_1fr] items-center gap-[3vw]" data-id="element-78" data-mp="g9wvn3d646zc">
        <div className="flex flex-col" data-id="element-79" data-mp="bb3hr9tyydyn">
          <Eyebrow data-id="element-80" data-mp="3jshv5ky37kgq">StartupFuel</Eyebrow>

          <h2 className="mt-[3vh] text-[clamp(16px,1.9vw,40px)] font-normal leading-tight text-[#C3CBD9]" style={{
          fontFamily: 'var(--font-serif)'
        }} data-id="element-81" data-mp="3jtj33gjt3qu8">
            The Venture Intelligence Company
          </h2>

          <Display className="mt-[1.6vh]" data-id="element-82" data-mp="3oscixfmkftxk">
            The Venture Brain
            <br data-id="element-83" data-mp="3oq9kq8b9euhr" />
            Is <span className="text-[#3B8CFF]" data-id="element-84" data-mp="3128gvcp1028o">Awake.</span>
          </Display>

          <Reveal delay={0.14} className="mt-[3.4vh] max-w-[86%]" data-id="element-85" data-mp="3105hw35wayrt">
            <Body data-id="element-86" data-mp="2w2vvyxhpt58q">
              One growing intelligence system learning from the companies,
              capital, decisions and outcomes of the global venture ecosystem.
            </Body>
          </Reveal>

          <Reveal delay={0.26} className="mt-[4vh] flex items-center gap-[1.4vw] border-t border-white/10 pt-[2.2vh]" data-id="element-87" data-mp="2m19kg1uspoji">
            <span className="text-[clamp(9px,0.94vw,20px)] font-semibold uppercase tracking-[0.28em] text-[#EEF2F9]" data-id="element-88" data-mp="2vtfd7dsvg9zr">
              StartupFuel
            </span>
            <span className="h-[1.6vh] w-px bg-white/15" data-id="element-89" data-mp="1y7hx1n1ysgqz" />
            <span className="text-[clamp(9px,0.94vw,20px)] tracking-[0.06em] text-[#8B95A8]" data-id="element-90" data-mp="2351a4jmxenhc">
              DiligenceGPT™ · Investor Presentation · 2026
            </span>
          </Reveal>
        </div>

        <div className="relative flex h-full items-center justify-center" data-id="element-91" data-mp="2c5ppbho22tvt">
          <BrainGraph density={0.55} className="h-[62vh] max-h-full w-auto max-w-full" data-id="element-92" data-mp="3jj9k7eqif4c3" />
        </div>
      </div>
    </Slide>;
}